<template lang="pug">
.cp-product1
    .page1
      .wrap.procuct-header
        .left-wrap
          p 智能企业电话
          p 突破手机限制的智能电话，一键跟进意向客户，访客流量直接变现
      product-list2(:config="productListConfig")
    content-list(:list="list")
    apply-list(:info="applyInfo", :img="applyImg", :logoList="logoList", @showModal="showModal")
    page-belt(:beltType="1", @showModal="showModal")
</template>
<script>
import productList2 from './components/product-list2'
import contentList from './components/content-list'
import applyList from './components/apply-list'

export default {
  components: {
    productList2,
    contentList,
    applyList,
  },
  props: {},
  data () {
    return {
      productListConfig: {
        img: 'weidu2.png',
        list: [
          { iconClass: 'icongoutongwuxian', label: '沟通无限', content: '一根网线、一台电脑，突破手机限制，一键沟通，轻松触达全国用户' },
          { iconClass: 'iconwuganzhuanjie', label: '人机协作', content: '与去电机器人联动，在线三方通话，人机协作，保障时效性' },
          { iconClass: 'iconhujiaobaogao', label: '呼叫报告', content: '呼叫报告实时生成，通话摘要一目了然，客户信息存储有序' },
          { iconClass: 'iconyiyuguanli', label: '易于管理', content: '呼叫报表自动生成，业绩透视可视化展现，独坐军帐中，指挥千军万马' },
        ]
      },
      list: [
        { title: '导入名单', content: '一键导入意向客户名单，免去重复拨号烦恼', labels: ['随时随地', '一键拨号', '入库有序'], imgSrc: require('@/assets/input-roster.png') },
        { title: '清晰通话', content: '音频双工通信，客户经理与意向客户清晰对话，业务介绍实时送达', labels: ['网线即可接入，简单方便', '音频双工通信，通话质量高', '业务交流顺畅无延迟'], imgSrc: require('@/assets/call-clearly.png') },
        { title: '呼后报告', content: '通话过程完整记录，可反复监听，检查。外呼人员自由备注。有效信息自动留存', labels: ['通话内容实时记录', '客户信息自由备注', '有效信息持久留存'], imgSrc: require('@/assets/call-report.png') },
        { title: '可视化管理', content: '可视化大屏展现每日工作数据，通话记录有序展现，轻松监听员工话术，管理团队得心应手', labels: ['员工业绩直观展现', '通话过程随时呼检', '报表完整管理便捷'], imgSrc: require('@/assets/visual-manage.png') },
      ],
      applyInfo: {
        titles: ['业务跟进', '售后回访', '客户关系维护'],
        content: '电话场景的业务跟进一直存在周期长、效率低等问题。智能企业电话操作方便、呼叫报告完整留存，可为企业提供完整的客户跟进策略，采用人机协作的方式，显著缩短转化周期，提高员工工作效率。'
      },
      applyImg: { src: require('../../assets/apply2.png'), style: 'width: 516px' },
      logoList: [
        { src: require('../../assets/apply-huanbei.png'), style: 'width: 51px' },
        { src: require('../../assets/apply-guazi.png'), style: 'width: 75px' },
        { src: require('../../assets/apply-tongcheng.png'), style: 'width: 88px' },
      ]
    }
  },
  computed: {},
  methods: {
    showModal (isShow) {
      this.$emit('showModal', isShow)
    }
  }
}
</script>
  <style lang="stylus">
  @import './config'
  .cp-product1
    .page1
      padding-top $topbar-height
      .procuct-header
        height 580px
        background: url("../../assets/product2.jpg") center no-repeat
        background-size: cover;
        margin-bottom -121px
        margin-top -94px
      .wrap
        position relative
        .left-wrap
          position absolute
          left 20%
          padding-top 178px
          width 389px
          p
            &:first-child
              font-size 36px
              margin-bottom 15px
            &:nth-child(2)
              font-size 16px
              color #D5DCEC
          .banner-btn
            margin-top 38px
      .banner-wrap
        position relative
  </style>
